// Pixels publicitaires (Meta + Google Ads) — chargés UNIQUEMENT si les identifiants
// sont configurés dans l'environnement. Sinon : aucun script tiers n'est injecté.
const META_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GTAG_ID = process.env.REACT_APP_GTAG_ID || "";
const GADS_LABEL = process.env.REACT_APP_GADS_CONVERSION_LABEL || "";

let initialized = false;

export function initPixels() {
  if (initialized) return;
  initialized = true;
  if (META_ID) {
    const n = (window.fbq = window.fbq || function (...a) { n.queue.push(a); });
    if (!n.queue) {
      n.queue = [];
      n.loaded = true;
      n.version = "2.0";
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
    }
    window.fbq("init", META_ID);
  }
  if (GTAG_ID && !window.gtag) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function (...a) { window.dataLayer.push(a); };
    window.gtag("js", new Date());
    window.gtag("config", GTAG_ID);
  }
}

export function trackPageView() {
  if (window.fbq) window.fbq("track", "PageView");
}

export function trackViewContent(p) {
  if (!p) return;
  if (window.fbq) window.fbq("track", "ViewContent",
    { content_ids: [p.id], content_name: p.name, content_type: "product", value: p.base_price, currency: "CAD" });
  if (window.gtag) window.gtag("event", "view_item",
    { currency: "CAD", value: p.base_price, items: [{ item_id: p.id, item_name: p.name }] });
}

export function trackAddToCart(item, value) {
  if (window.fbq) window.fbq("track", "AddToCart",
    { content_ids: [item.product_id], content_name: item.name, value, currency: "CAD" });
  if (window.gtag) window.gtag("event", "add_to_cart",
    { currency: "CAD", value, items: [{ item_id: item.product_id, item_name: item.name }] });
}

export function trackInitiateCheckout(value) {
  if (window.fbq) window.fbq("track", "InitiateCheckout", { value, currency: "CAD" });
  if (window.gtag) window.gtag("event", "begin_checkout", { currency: "CAD", value });
}

export function trackPurchase(orderNumber, value) {
  if (window.fbq) window.fbq("track", "Purchase", { value, currency: "CAD" });
  if (window.gtag) {
    window.gtag("event", "purchase", { transaction_id: orderNumber, currency: "CAD", value });
    if (GADS_LABEL) window.gtag("event", "conversion",
      { send_to: `${GTAG_ID}/${GADS_LABEL}`, transaction_id: orderNumber, currency: "CAD", value });
  }
}
